window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', 'G-R5XWPWF3VD');

// Remember visitors that arrived from a Google Ads click (?gclid=), the free trial form sends it to WHMCS as a
// custom field. Only called once the visitor has accepted cookies, it isn't strictly necessary. On later requests
// includes/bootstrap.php sets it, which is why it isn't restricted to this page.
function rememberGoogleAdsVisit() {
    if (! new URLSearchParams(window.location.search).has('gclid')) {
        return;
    }

    document.cookie = 'came_from_google_ads=Yes; max-age=' + (30 * 24 * 60 * 60) + '; path=/; samesite=lax'
        + (window.location.protocol === 'https:' ? '; secure' : '');
}

$(document).ready(function() {
    window.cookieconsent.initialise({
        content: {
            allow: 'Got it!',
            message: 'By continuing to use this website, you consent to the use of cookies in accordance with our <a target="_blank" href="/company/privacy#cookies">Privacy Policy</a>.',
        },
        elements: {
            messagelink: '<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',
        },
        palette: false,
        theme: "edgeless",
        position: "bottom",
        type: "opt-out",
        revokable: false,
        onInitialise: function (status) {
            if (this.hasConsented()) {
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
                rememberGoogleAdsVisit();
            }
        },
        onStatusChange: function (status, chosenBefore) {
            if (this.hasConsented()) {
                gtag('consent', 'update', {
                    'ad_storage': 'granted',
                    'analytics_storage': 'granted'
                });
                rememberGoogleAdsVisit();
            }
        }
    });
});
